import * as React from 'react';
import {Link} from "react-router-dom";
import {lazyInject} from "@athena-portal/core";
import {authorize} from "@athena-portal/components";
import {
    Policy,
    productHelper,
    ProductsEnum,
    Quote,
} from "@ferry/journey-services";
import {FalconNavigatorHeader, resourcesHelper, Footer} from "@ferry/portal-core";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {Types as CustomerPortalTypes} from "../../../../Types";
import type {ICustomerPortalService} from "../../../../services/ICustomerPortalService";

interface IState {
    policies?: Policy[];
    quotes?: Quote[];
    annualMotorQuotes: Quote[];
}

@authorize
export class ViewOrGetQuotesPage extends React.Component<{}, IState> {

    private pluginTemplates = new PluginTemplates();
    private readonly ANNUAL_QUOTES_PAGE: string = "/dashboard/annualQuotes";

    @lazyInject(CustomerPortalTypes.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: Readonly<{}>) {
        super(props);
        this.state = {
            annualMotorQuotes: [],
        }
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Get a new quote or view saved quotes");
        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => {
            this.setState({
                annualMotorQuotes: this.getQuotesByProduct(quotes, ProductsEnum.WOLF_MOTOR),
                quotes
            });
        });

        this.customerPortalService.getPolicies().subscribe((policies: Policy[]) => {
            this.setState({policies});
        });
    }

    public render() {
            return (
                <React.Fragment>
                    <FalconHeader/>
                            <div className="plugin view-or-get-quotes-page">
                                <FalconNavigatorHeader back="/dashboard" title="Get a new quote or view saved quotes"/>
                                <div className="view-or-get-quotes-content">
                                    <div className="panel bg-white overflow-hidden p-0 mx-3 font-weight-extra-light mb-4">
                                        <div className="inner-content pb-4">
                                            <div className="d-flex">
                                                <div className="product-section-home-logo d-flex">
                                                    <img className="home-icon"
                                                         src={`/${resourcesHelper.THEME_PATH}/img/wolf-car-icon.png`}
                                                         alt="Vehicle icon"/>
                                                </div>
                                                <div className="product-section-defaqto-logo d-flex col-sm">
                                                    <img className="defaqto-logo-sm"
                                                         src="/img/DefaqtoLogo.svg"
                                                         alt="Defaqto logo"
                                                         aria-label="Defaqto logo"/>
                                                </div>
                                            </div>

                                            {resourcesHelper.THEME === "Allianz" &&
                                                <div className="quote-panel-title mt-4">Allianz Car Insurance</div>}
                                            <div className="quote-panel-description text-center px-3">
                                                <p className="product-description mb-0">
                                                    Cover the basics with <b>Essentials</b> or choose our Defaqto
                                                    5 Star rated <b>Plus</b> cover level. Trust us to keep car
                                                    insurance simple.
                                                </p>
                                            </div>
                                            <Link
                                                to={`${productHelper.getNewBusinessUrl(ProductsEnum.WOLF_MOTOR)}/dashboardEntryPage`}
                                                className="inner-content buttonLink"
                                                id="viewSavedSubscriptionCarQuotes">
                                                <button type="button" className="btn btn-primary btn-add">
                                                    Annual car quote
                                                </button>
                                            </Link>
                                            <div className="quote-panel-view-quotes">
                                                {
                                                    this.state.annualMotorQuotes.length > 0
                                                        ? <Link
                                                            to={this.ANNUAL_QUOTES_PAGE}>
                                                            View your saved car quotes
                                                        </Link>
                                                        :<p className="mb-0">
                                                            You don't have any car quotes
                                                        </p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                            </div>
                    <Footer/>
                </React.Fragment>
            )
    }

    private getQuotesByProduct(quotes: Quote[], product: string): Quote[] {
        return quotes?.filter((quote) => quote?.product === product);
    }
}
